import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BuildingOffice2Icon, ArrowRightIcon } from '@heroicons/react/24/outline';

const ViewManagedPropertiesQuickAction: React.FC = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/landlord-toolkit/managed-properties')}
      className="w-full group flex items-center justify-between p-4 sm:p-6 bg-white border border-gray-200 rounded-xl sm:rounded-2xl shadow-sm hover:shadow-md hover:border-blue-500 transition-all duration-200 text-left"
    >
      <div className="flex items-center gap-4 sm:gap-5">
        <div className="p-3 sm:p-4 bg-blue-50 text-blue-600 rounded-lg sm:rounded-xl group-hover:bg-blue-100 transition-colors">
          <BuildingOffice2Icon className="w-6 h-6 sm:w-8 sm:h-8" />
        </div>
        <div>
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-1">
            View Managed Properties
          </h3>
          <p className="text-gray-500 text-sm sm:text-base leading-snug sm:leading-relaxed">
            Access your portfolio dashboard.
          </p>
        </div>
      </div>
      <div className="hidden sm:flex bg-blue-600 text-white rounded-full p-2 ml-4 group-hover:bg-blue-700 transition-colors">
        <ArrowRightIcon className="w-6 h-6" />
      </div>
    </button>
  );
};

export default ViewManagedPropertiesQuickAction;
